var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2441 2.12109C6.4462 2.12109 2.55225 6.01505 2.55225 10.813C2.55225 15.6109 6.4462 19.5048 11.2441 19.5048C16.042 19.5048 19.936 15.6109 19.936 10.813C19.936 6.01505 16.042 2.12109 11.2441 2.12109ZM7.20239 16.4627C8.34102 15.6456 9.73172 15.1589 11.2441 15.1589C12.7565 15.1589 14.1472 15.6456 15.2858 16.4627C14.1472 17.2797 12.7565 17.7664 11.2441 17.7664C9.73172 17.7664 8.34102 17.2797 7.20239 16.4627ZM16.5809 15.2632C15.112 14.1159 13.2606 13.4205 11.2441 13.4205C9.22759 13.4205 7.37623 14.1159 5.9073 15.2632C4.89905 14.055 4.29062 12.5079 4.29062 10.813C4.29062 6.97115 7.4023 3.85947 11.2441 3.85947C15.0859 3.85947 18.1976 6.97115 18.1976 10.813C18.1976 12.5079 17.5892 14.055 16.5809 15.2632Z",
    fill: "#0059A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2441 5.59784C9.56658 5.59784 8.20196 6.96246 8.20196 8.63999C8.20196 10.3175 9.56658 11.6821 11.2441 11.6821C12.9216 11.6821 14.2863 10.3175 14.2863 8.63999C14.2863 6.96246 12.9216 5.59784 11.2441 5.59784ZM11.2441 9.94377C10.5227 9.94377 9.94033 9.36141 9.94033 8.63999C9.94033 7.91856 10.5227 7.33621 11.2441 7.33621C11.9655 7.33621 12.5479 7.91856 12.5479 8.63999C12.5479 9.36141 11.9655 9.94377 11.2441 9.94377Z",
    fill: "#0059A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfileIcon);
export default __webpack_public_path__ + "static/media/my_profile_icon.a098dbc4c1ae535a3fffa320e1c98fa2.svg";
export { ForwardRef as ReactComponent };